import { Form, Input, message, Modal, Select } from "antd";
import {
  useAddDebtorAssetCategoryMutation,
  useUpdateDebtorAssetCategoryMutation,
} from "features/debtorAssetCategories/debtorAssetCategoriesAPI";

export default function DebtorAssetCategoryModal({
  record,
  customFields = [],
  open,
  onOk,
  onCancel,
}) {
  const [form] = Form.useForm();
  const [addCategory, { isLoading: isAdding }] = useAddDebtorAssetCategoryMutation();
  const [updateCategory, { isLoading: isUpdating }] = useUpdateDebtorAssetCategoryMutation();

  const isNew = !record;
  const isLoading = isAdding || isUpdating;

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const apiData = {
        name: values.name,
        notes: values.notes || "",
        customFieldIds: values.customFieldIds || [],
      };

      let response;
      if (record) {
        response = await updateCategory({ id: record.id, ...apiData });
      } else {
        response = await addCategory(apiData);
      }

      if ("data" in response) {
        message.success(`Category ${record ? "updated" : "created"} successfully`);
        onOk();
      }
    } catch (error) {
      // Form validation failed
    }
  };

  // Build custom field options for multi-select
  const customFieldOptions = customFields.map((field) => ({
    label: field.name,
    value: field.id,
  }));

  const initialValues = record
    ? {
        name: record.name,
        notes: record.notes,
        customFieldIds: record.debtorAssetCustomFieldIds || [],
      }
    : {
        customFieldIds: [],
      };

  return (
    <Modal
      title={isNew ? "Add Debtor Asset Category" : "Edit Debtor Asset Category"}
      open={open}
      onOk={handleSubmit}
      onCancel={onCancel}
      okButtonProps={{ loading: isLoading }}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" initialValues={initialValues}>
        <Form.Item
          name="name"
          label="Category Name"
          rules={[{ required: true, message: "Please enter category name" }]}
        >
          <Input placeholder="Enter category name (e.g., Real Estate, Vehicles)" />
        </Form.Item>

        <Form.Item name="notes" label="Description">
          <Input.TextArea placeholder="Enter category description" rows={3} />
        </Form.Item>

        <Form.Item
          name="customFieldIds"
          label="Custom Fields"
          tooltip="Select custom fields that will be available for assets in this category"
        >
          <Select
            mode="multiple"
            allowClear
            showSearch
            popupMatchSelectWidth={false}
            maxTagTextLength={20}
            placeholder="Select custom fields"
            options={customFieldOptions}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
